import { Currency } from "app/components/ido-details/sale-widget/sale-widget";
import { useTheme } from "app/shared";
import usdcIcon from "assets/img/icons/usdc.svg";
import usdtIcon from "assets/img/icons/usdt.svg";
import { FC } from "react";
import styles from "./TokenSelect.module.scss";

interface TokenSelectProps {
  selectedToken: Currency.USDC | Currency.USDT;
  onChange: (value: Currency.USDC | Currency.USDT) => void;
}

const TokenSelect: FC<TokenSelectProps> = ({ selectedToken, onChange }) => {
  const { theme } = useTheme();

  return (
    <>
      <label htmlFor="token-select" className={styles.label}>
        <span>Select Token:</span>
      </label>
      <div className={styles.customSelectWrapper}>
        <span className={styles.selectedIcon}>
          <img
            src={selectedToken === Currency.USDC ? usdcIcon : usdtIcon}
            alt={selectedToken}
          />
        </span>
        <select
          id="token-select"
          className={`${styles.select} ${
            theme === "dark" ? styles.darkTheme : ""
          }`}
          value={selectedToken}
          onChange={(e) =>
            onChange(e.target.value as Currency.USDC | Currency.USDT)
          }
        >
          <option value={Currency.USDC}>USDC</option>
          <option value={Currency.USDT}>USDT</option>
        </select>
      </div>
    </>
  );
};

export default TokenSelect;
